import React, { useState } from 'react';
import { SectionHeading } from '../SectionHeading';
import { Carousel } from '../Carousel';
import { ZoomablePage } from '../ZoomablePage';
import { Lightbox } from '../Lightbox/Lightbox';
import { INTERIOR_SAMPLES } from '../../data/collection';

/** Frame every sample at the tallest page ratio so cards share baselines; pages are contained, never cropped. */
const tallest = INTERIOR_SAMPLES.reduce((a, b) => b.height / b.width > a.height / a.width ? b : a);
const FRAME_RATIO = `${tallest.width} / ${tallest.height}`;
const lightboxItems = INTERIOR_SAMPLES.map(sample => ({
  src: sample.src,
  alt: sample.alt,
  file: sample.file,
  caption: `${sample.title} · ${sample.volume}, ${sample.model}`,
  width: sample.width,
  height: sample.height
}));
export function InteriorPagesSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="paginas" aria-labelledby="paginas-title" className="w-full bg-paper" data-id="element-219" data-mp="39ggwowhax4up">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-220" data-mp="39it9ywc46r1f">
        <SectionHeading id="paginas-title" title="Así son los manuales y moldes que recibís" intro="Cuatro páginas reales de distintos volúmenes y modelos. Tocá cualquiera para verla completa y acercarte a los detalles." data-id="element-221" data-mp="f7qvomttv4yi" />

        <div className="mt-10" data-id="element-222" data-mp="t89ynfjfrktt">
          <Carousel items={INTERIOR_SAMPLES} label="Páginas interiores de la colección" grid="md-2-lg-4" getKey={sample => sample.file} renderItem={(sample, index) => <article className="flex w-full flex-col" data-id="element-224" data-mp="5ifml06xy0am">
                <ZoomablePage image={sample} label={`${sample.title} · ${sample.volume}, ${sample.model}`} onOpen={() => setOpen(index)} frameRatio={FRAME_RATIO} data-id="element-225" data-mp="5hnsjtszsamg" />
                <p className="mt-4 text-[0.88rem] font-bold text-sage-ink" data-id="element-226" data-mp="3dxzb5lwo2ujc">
                  {sample.volume} · {sample.model}
                </p>
                <h3 className="mt-1 font-serif text-[1.3rem] font-semibold leading-tight text-graphite" data-id="element-227" data-mp="l27jypqdjjyp">{sample.title}</h3>
                <p className="mt-2 text-[1rem] leading-relaxed text-graphite-soft" data-id="element-228" data-mp="g2l56buwdvns">{sample.description}</p>
              </article>} data-id="element-223" data-mp="t7i2o3lxfl30" />
        </div>
      </div>

      <Lightbox items={lightboxItems} index={open} onClose={() => setOpen(null)} onNavigate={setOpen} label="Páginas interiores" data-id="element-229" data-mp="pv0n59672k8o" />
    </section>;
}